var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { jsx } from '@emotion/core';
import { COLORS, FONT } from '../../../constants';
import Badge from './badge';
import { itemStyles } from './item';
var linkStyles = {
  height: 32,
  display: 'flex',
  alignItems: 'center',
  fontSize: FONT.sizes.regular.fontSize,
  lineHeight: FONT.sizes.regular.lineHeight,
  color: COLORS.blues.primary,
  cursor: 'pointer',
  '&:hover': {
    color: '#2471b3',
    span: {
      backgroundColor: '#2471b3'
    }
  }
};
var secondaryStyles = {
  color: COLORS.grays.dark,
  '&:hover': {
    color: COLORS.grays.darkest
  }
};
var inlineStyles = {
  display: 'inline',
  marginLeft: 16
};
export var Link = function Link(_a) {
  var secondary = _a.secondary,
      _b = _a.badge,
      badge = _b === void 0 ? 0 : _b,
      children = _a.children,
      onClick = _a.onClick,
      inline = _a.inline,
      id = _a.id;
  var styles = [linkStyles];
  if (secondary) styles.push(secondaryStyles);
  if (inline) styles.push(inlineStyles);
  return jsx("span", {
    css: styles,
    onClick: onClick,
    "data-testid": id
  }, children, badge > 0 && jsx(Badge, null, badge));
};

var LinkItem = function LinkItem(props) {
  return jsx("div", {
    css: itemStyles
  }, jsx(Link, __assign({}, props)));
};

export default LinkItem;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Header/filters/link.js
// module id = 221
// module chunks = 0